import React, { FC } from 'react';
import cls from 'classnames';

import { INavItem } from 'src/prize/types/shoppe';

import LinksComponent from '../../../../../../molecules/Links';

import styles from './index.module.sass';

interface LinksProps {
  data?: INavItem;
  overlay: boolean;
}

const Links: FC<LinksProps> = ({ data, overlay }) => (
  <LinksComponent
    className={{
      container: cls( styles.container, {
        [styles.overlay]: overlay,
      }),
      dropdownLink: styles.dropdownLink,
      link: cls( styles.link, { [styles.visible]: overlay }),
    }}
    data={data}
  />
);

export default Links;
